<div class="notification-type">
  <div>
    <h3>Configure Notification</h3>
  </div>

  @if (currentNotification()) {
    <div class="main-content">
      <div class="columns">
        <div class="column is-2">
          <span>Notification Type</span>
        </div>
        <div class="column is-3 field">
          <div class="control">
            <div class="select">
              <select [(ngModel)]="currentNotification().notificationType" [compareWith]="this.compareFn"
                (change)="notificationTypeChanged()" [attr.disabled]="isNotificationTypeNotify() ? '' : null"
                [disabled]="!this.isEditable">
                @if (!isNotificationTypeNotify()) {
                  <option value=null selected>-- Select --</option>
                }
                @if (isNotificationTypeNotify()) {
                  <option selected [ngValue]="currentNotification().notificationType">
                    {{currentNotification().notificationType.value }}
                  </option>
                }
                @for (nType of notificationTypesList; track nType) {
                  <option [ngValue]="nType">
                    {{nType.value}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      @if (isValidNotificationSelected()) {
        <div>
          <!---- ACCRUAL Type  -->
          @if (isTypeAccrual()) {
            <div class="columns">
              <div class="column is-2">
                <span> Accrual Type</span>
              </div>
              <div class="column field">
                <div class="control">
                  <div class="select">
                    <select [(ngModel)]="currentNotification().notificationAccrualDetail.accrualType"
                      [compareWith]="this.compareFn" (change)="accrualTypeSelected()" [disabled]="!this.isEditable">
                      <option value=null selected>-- Select --</option>
                      @for (nType of accrualTypesList; track nType) {
                        <option [ngValue]="nType">
                          {{nType.value}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div class="column"></div>
            </div>
          }
          <!---- ACCRUAL Type  -->
          <!---   EVENTS -->
          @if (shouldShowEvents()) {
            <div class="columns">
              <div class="column is-2">
                <span>Schema Event</span>
              </div>
              <div class="column is-3 field">
                <div>
                  @if (displayEvents.length===0) {
                    <span>No qualifying events currently defined</span>
                  }
                  <ul>
                    @for (evt of displayEvents; track evt; let rowIdx = $index) {
                      <li>
                        <label class="checkbox">
                          <input type="checkbox" name="regEvt-{{rowIdx}}" (click)="eventSelectionClicked()"
                            [(ngModel)]="selectedEventList[rowIdx]" [disabled]="!this.isEditable">
                            {{getEventDisplayName(evt)}} - {{evt.keyEventMappingId}}
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                <div class="column"></div>
              </div>
            }
            <!--- EVENTS -->
            <!--- Notify at  - APPROVAL TYPE -->
            @if (isTypeApproval()) {
              <div class="columns">
                <div class="column is-2 ">
                  <span>Notify At</span>
                </div>
                <div class="column field">
                  <ul>
                    @for (apprType of approvalTypesList; track apprType) {
                      <li>
                        <label class="checkbox">
                          <input type="checkbox" [ngModel]="isSelected(apprType)"
                            (ngModelChange)="toggleSelection($event, apprType)" [disabled]="!this.isEditable">
                            {{apprType.desc}}
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
              <!--- Notify at  - APPROVAL TYPE -->
              <!--  Grouping Factor   -->
              @if (shouldShowGroupingFactors()) {
                <div class="columns">
                  <div class="column is-2">
                    <span>Grouping Factor</span>
                  </div>
                  <div class="column is-8 field">
                    <div>
                      @if (groupingFactors.length===0) {
                        <span>No qualifying grouping factors currently defined</span>
                      }
                      <ul>
                        @for (item of groupingFactors; track item; let rowIdx = $index) {
                          <li>
                            <label class="checkbox" [ngClass]="{'grey-out': item.isFromOldVersion === 1}">
                              <input type="checkbox" name="grp-factor-{{rowIdx}}" (click)="gfSelectionClicked()"
                                [(ngModel)]="selectedGroupingFactors[rowIdx]" [disabled]="item.isFromOldVersion === 1 || !this.isEditable">
                                {{getGroupingFactorDisplay(item)}}
                              </label>
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                    <div class="column"></div>
                  </div>
                }
                <!--  Grouping Factor   -->
                <!-- Variable valid values -->
                @if (shouldShowValidValues()) {
                  <div class="columns">
                    <div class="column is-2">
                      <span>Variable valid values</span>
                    </div>
                    <div class="column is-8 field">
                      <div class="valid-value-selection">
                        @if (formsValidValueList.length===0) {
                          <span>No qualifying forms valid value currently defined</span>
                        }
                        <ul>
                          @for (item of formsValidValueList; track item; let rowIdx = $index) {
                            <li>
                              <label class="checkbox" [ngClass]="{'grey-out': item.isFromOldVersion}">
                                <input type="checkbox" name="valid-value-{{rowIdx}}" (click)="vvSelectionClicked()"
                                  [(ngModel)]="selectedValidValues[rowIdx]" [disabled]="item.isFromOldVersion === 1 || !this.isEditable">
                                  {{getValidValueDisplay(item)}}
                                </label>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                      <div class="column"></div>
                    </div>
                  }
                  <!-- End of Variable valid values -->
                  <!--  Slot Groups   -->
                  @if (shouldShowSlotGroups()) {
                    <div class="columns">
                      <div class="column is-2">
                        <span>Slot Group</span>
                      </div>
                      <div class="column is-8 field">
                        <div>
                          @if (slotGroups.length===0) {
                            <span>No slot groups currently defined</span>
                          }
                          <ul>
                            @for (item of slotGroups; track item; let rowIdx = $index) {
                              <li>
                                <label class="checkbox">
                                  <input type="checkbox" name="grp-factor-{{rowIdx}}" (click)="sGSelectionClicked()"
                                    [(ngModel)]="selectedSlotGroups[rowIdx]" [disabled]="!this.isEditable">
                                    {{item.groupDescription}}
                                  </label>
                                </li>
                              }
                            </ul>
                          </div>
                        </div>
                        <div class="column"></div>
                      </div>
                    }
                    <!--  End of Slot Groups   -->
                    @if (isTypeAccrual()) {
                      <div class="columns is-horizontal">
                        <div class="column is-2 ">
                          <span>Notify At</span>
                        </div>
                        <div class="column is-2 field">
                          <div class="control">
                            <div class="select">
                              <select [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPointType"
                                [compareWith]="this.compareFn" [disabled]="!this.isEditable">
                                <option value=null selected>-- Select --</option>
                                @for (nType of accrualPointsList; track nType) {
                                  <option [ngValue]="nType">
                                    {{nType.value}}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="column"></div>
                        @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === 'Every (x) Patients') {
                          <div class="column is-8"
                            >
                            <div class="columns">
                              <span class="column is-2">For Every:</span>
                              <div class="column ">
                                <div class="field is-horizontal">
                                  <div class="control ">
                                    <input class="form-control input" placeholder="number" id="for-every" name="forEvery"
                                      [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint"
                                      [disabled]="!this.isEditable">
                                    </div>&nbsp;&nbsp;
                                    <span>Patients</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === 'a (%) of Patients') {
                            <div class="column is-8"
                              >
                              <div class="columns">
                                <div class="column">
                                  <div class="field is-horizontal">
                                    <div class="control ">
                                      <input class="form-control input" placeholder="number" id="percent" name="percent"
                                        [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint"
                                        [disabled]="!this.isEditable">
                                      </div>&nbsp;&nbsp;
                                      <span>%</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === '(xth) Patient') {
                              <div class="column is-8"
                                >
                                <div class="columns">
                                  <div class="column is-6">
                                    <div class="field is-horizontal">
                                      <div class="control ">
                                        <input class="form-control input" placeholder="number" id="xth-patient" name="xthPatient"
                                          [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint"
                                          [disabled]="!this.isEditable">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      <div class="columns">
                        <div class="  column is-2">
                          <div class=" field is-horizontal ">
                            <span>Notes</span>
                          </div>
                        </div>
                        <div class="column is-7">
                          <div class="field is-horizontal ">
                            <div class="field-body text-field-padding ">
                              <div class="field">
                                <div class="control ">
                                  <textarea placeholder="Notes" name="notes" id="body" class="textarea width-100-percent" rows="6"
                                    [(ngModel)]="currentNotification().notes" [attr.disabled]="isNotificationTypeNotify() ? '' : null"
                                  [disabled]="!this.isEditable"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>